module.exports = __webpack_public_path__ + "static/media/patient-assistance-program-600x400.946e68be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/mi-app/home/assets/patient-assistance-program-600x400.jpg
// module id = 1084
// module chunks = 1